export const SHAREPOINT_RESOURCE_TYPES: string[] = ['document'];
